/**
 * Qui pose la question quand on quitte une page en travail.
 *
 * Le <Prompt> de react-router s'en remet a window.confirm : une boite grise
 * du navigateur, qui ne ressemble a rien du produit. Retour de Nicolas du
 * 04/09 : il quitte un dossier ouvert et « n'a pas eu d'alerte ». Il attendait
 * la fenetre de Lybo, celle qui lui propose de marquer le dossier cree en
 * partant — pas un avertissement anonyme qu'on clique sans le lire.
 *
 * Ce relais laisse la page poser la question elle-meme. Tant qu'aucune page ne
 * s'est annoncee, on retombe sur window.confirm : mieux vaut une boite laide
 * qu'une navigation silencieuse.
 */

let poseurQuestion = null;

/** Une page prend la main sur la question. Rend de quoi la rendre. */
export function installerPoseurQuestion(fn) {
  poseurQuestion = fn;
  return () => {
    if (poseurQuestion === fn) poseurQuestion = null;
  };
}

/** Signature attendue par le `getUserConfirmation` de react-router. */
export function demanderConfirmationNavigation(message, repondre) {
  if (poseurQuestion) {
    poseurQuestion(message, repondre);
    return;
  }
  repondre(window.confirm(message));
}
